import commonUtilities from "utilities/common";
import { CONFIGURATION } from "utilities/configuration";
import { productModel } from "./product";

function getProducts(isIQMUser) {
    let products = [];
    let _isIQMUser =  isIQMUser ?? commonUtilities.isIQMUser();

    [...Array(_isIQMUser ? CONFIGURATION.NUMBER_OF_PRODUCTS_IQM : CONFIGURATION.NUMBER_OF_PRODUCTS)].forEach(() =>
        products.push(productModel)
    );

    return products;
}

export const productsModel = (isIQMUser) => getProducts(isIQMUser);
